import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { posDevice, PosDeviceManipulationViewModel } from "./posDeviceManipulation-viewModel"

export class PosDeviceManipulationView extends View<PosDeviceManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-5A7D3D4E-46AC-47E1-87B7-14F09AE7C595"
    }
    loadHtml(): string {
        let element = require('./posDeviceManipulation.html').default;
        let style = require('./posDeviceManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set posDevice(v: ObservableArray<posDevice>) { this._posDevice = v; } public get posDevice(): ObservableArray<posDevice> { return this._posDevice;} private _posDevice: ObservableArray<posDevice>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    requestPosDeviceCreation(){
        this.dataContext.requestPosDeviceCreation();
    }
}
